import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllSiteVisitList, getAllInspectionsList, getAllInspectionTimeList } from "../../Thunks/SiteVisitThunks";
import { SiteVisit, InspectionList, InspectionTimeList } from "../../Types/SiteVisit/SiteVisitTypes";

interface SiteVisitSliceState {
    // For Site visit list data
    siteVisitLoading: boolean; // for refresh pages and inital loadings
    siteVisitList: SiteVisit[];
    siteVisitError: string | null;

    // For Inspention list data
    inspectionListLoading: boolean; // for refresh pages and inital loadings
    inspectionList: InspectionList[];
    inspectionListError: string | null;

    // For Inspention time list data
    inspectionTimeListLoading: boolean; // for refresh pages and inital loadings
    inspectionTimeList: InspectionTimeList[];
    inspectionTimeListError: string | null;
}

// set inital values
const initialState: SiteVisitSliceState = {
    siteVisitLoading: false,
    siteVisitList: [],
    siteVisitError: '',

    inspectionListLoading: false,
    inspectionList: [],
    inspectionListError: '',

    inspectionTimeListLoading: false,
    inspectionTimeList: [],
    inspectionTimeListError: '',
}

// set state value for api response
const siteVisitSlice = createSlice({
    name: 'siteVisitSlice',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            // For Site visit list data
            .addCase(getAllSiteVisitList.rejected, (state, action) => {
                state.siteVisitLoading = false;
                state.siteVisitError = action.error.message!;
            })
            .addCase(getAllSiteVisitList.pending, state => {
                state.siteVisitLoading = true;
                state.siteVisitError = null;
            })
            .addCase(getAllSiteVisitList.fulfilled, (state, action: PayloadAction<SiteVisit[]>) => {
                state.siteVisitList = [];
                state.siteVisitLoading = false;
                state.siteVisitList = action.payload;
            })

            // For Inspection list data
            .addCase(getAllInspectionsList.rejected, (state, action) => {
                state.inspectionListLoading = false;
                state.inspectionListError = action.error.message!;
            })
            .addCase(getAllInspectionsList.pending, state => {
                state.inspectionListLoading = true;
                state.inspectionListError = null;
            })
            .addCase(getAllInspectionsList.fulfilled, (state, action: PayloadAction<InspectionList[]>) => {
                state.inspectionList = [];
                state.inspectionListLoading = false;
                state.inspectionList = action.payload;
            })

            // For Inspection time list data
            .addCase(getAllInspectionTimeList.rejected, (state, action) => {
                state.inspectionTimeListLoading = false;
                state.inspectionTimeListError = action.error.message!;
            })
            .addCase(getAllInspectionTimeList.pending, state => {
                state.inspectionTimeListLoading = true;
                state.inspectionTimeListError = null;
            })
            .addCase(getAllInspectionTimeList.fulfilled, (state, action: PayloadAction<InspectionTimeList[]>) => {
                state.inspectionTimeList = [];
                state.inspectionTimeListLoading = false;
                state.inspectionTimeList = action.payload;
            })
    }
})

export const { } = siteVisitSlice.actions
export default siteVisitSlice.reducer
